import { useLocale, useTranslations } from 'next-intl';
import type { MouseEventHandler } from 'react';

import { EventType } from '@/analytics/types';
import ArticleCardsModule from '@/app/components/ArticleCardsModule';
import ArticleCardTag from '@/app/components/ArticleCardsModule/ArticleCardTag';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import sleepAndRestBlogs from './data/sleepAndRestBlogs';

const SleepAndRestBlog = () => {
  const t = useTranslations();
  const locale = useLocale();
  const articles = sleepAndRestBlogs(getLocalePartialUrl(locale));

  const handleLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;
    const url = new URL(href);
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'read_more',
      location: 'sleep and health',
      action: 'goes to blog',
      path: url.pathname,
    });
  };

  return (
    <section data-cy="sleep-and-rest-blog">
      <ArticleCardsModule
        {...articles}
        eyebrowText="sleep_and_rest_cta_eyebrow"
        eyebrowTextColor="light"
        imageTag={() => (
          <ArticleCardTag
            tag="sleep_and_rest_cta_tag_alt"
            textColor="sandstone-500"
          />
        )}
        mobileSliderAriaLabels={[
          t('sleep_and_rest_cta_article_one'),
          t('sleep_and_rest_cta_article_two'),
          t('sleep_and_rest_cta_article_three'),
        ]}
        onClick={handleLinkClick}
        swipeableDotsProps={{
          activeColor: 'gray-200',
          color: 'gray-400',
        }}
        wrapperClass="text-slate-600 bg-slate-600"
      />
    </section>
  );
};

export default SleepAndRestBlog;
